module.exports = __webpack_public_path__ + "img/top3.fe0caa1f.png";